import server from "../../../server";
import { ICreateEventPayload, ICustomCalendarEvents } from "../type/events.types";
import dayjs from "dayjs";
import moment from "moment";
import { formatDate, formatTime } from "../utils/utils";

export async function getEvent(startDate: string, endDate: string) {
    const response = await server.event.list({
        'start-date': startDate,
        'end-date': endDate
    });
    return response;
}

export async function getEventById(id: string) {
    const res = await server.event.getById(id);
    return res;
}

export async function createEvent(data: ICreateEventPayload) {
    const res = await server.event.create(data);
    return res;
}

export async function updateEvent(eventId: string, data: any) {
    const res = await server.event.update(eventId, data);
    return res;
}

export async function deleteEvent(eventId: string) {
    await server.event.delete(eventId);
}

export async function cancelEvent(eventId: string, reason: string) {
    await server.event.cancel(eventId, reason);
}

export async function uploadEventPhotos(eventId: string, imageIds: string[]) {
    const res = await server.event.upload(eventId, imageIds);
    return res;
}

export function mapEventFormToPayload(values: any): ICreateEventPayload {

    return {
        name: values.name,
        venue: values.venue,
        hostBy: values.hostBy,
        description: values.description,
        startTime: formatTime(values.time[0]),
        endTime: formatTime(values.time[1]),
        startDate: formatDate(values.date[0]),
        endDate: formatDate(values.date[1]),
        coverImageId: values.coverImageId,
        active: true,
        externalEmails: values.externalEmails,
        eventType: values.eventType
    }
}

export const mapEventToForm = (values: any) => {
    if (!values) return values;
    return {
        active: true,
        id: values.id,
        name: values.name,
        venue: values.venue,
        hostBy: values.hostBy,
        description: values.description,
        coverImageId: values?.coverImage?.id,
        date: [dayjs(values.startDate), dayjs(values.endDate)],
        externalEmails: values.externalEmails,
        eventType: values.eventType,
        time: values.startDate && values.endDate ?
            [dayjs(values.startTime, "HH:mm:ss"), dayjs(values.endTime, "HH:mm:ss")]
            : undefined
    };
};

export function mapPayloadToCalendarEvent(eventId: string, payload: ICreateEventPayload): ICustomCalendarEvents {
    return {
        id: eventId,
        title: payload.name,
        coverImageId: payload.coverImageId,
        start: moment(`${payload.startDate} ${payload.startTime}`).toDate(),
        end: moment(`${payload.endDate} ${payload.endTime}`).toDate(),
        description: payload.description,
        hostBy: payload.description,
        venue: payload.venue,
        eventType: payload.eventType,
        eventStatus: "CANCELLED" || "PLANNED" || "COMPLETED",
    };
}
